export type ThemePreference = 'light' | 'dark' | 'system'

const STORAGE_KEY = 'domusaurea_theme_preference'

export function getThemePreference(): ThemePreference {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored === 'light' || stored === 'dark' || stored === 'system' ? stored : 'system'
}

export function applyThemePreference(preference: ThemePreference): void {
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const resolvedTheme = preference === 'system' ? (prefersDark ? 'dark' : 'light') : preference
  document.documentElement.dataset.theme = resolvedTheme
  document.documentElement.style.colorScheme = resolvedTheme
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', resolvedTheme === 'dark' ? '#111827' : '#f4f6f9')
}

export function setThemePreference(preference: ThemePreference): void {
  localStorage.setItem(STORAGE_KEY, preference)
  applyThemePreference(preference)
}

export function initializeThemePreference(): void {
  const preference = getThemePreference()
  applyThemePreference(preference)
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (getThemePreference() === 'system') applyThemePreference('system')
  })
}
